export default {
  props: {
    languages: Array,
    selected: String,
  },
  data() {
    return {
      localSelected: this.selected || null,
    };
  },
  computed: {
    selectOptions() {
      return this.languages.map(l => ({
        text: this.$t(`terms.language.name.${l}`),
        value: l,
      }));
    },
  },
  watch: {
    languages(newLanguages) {
      if (newLanguages.findIndex(l => l === this.localSelected) === -1) {
        this.localSelected = newLanguages.length ? newLanguages[0] : null;
      }
    },
    localSelected(newLocalSelected) {
      this.$emit('update:selected', newLocalSelected);
    },
    selected(newSelected) {
      this.localSelected = newSelected;
    },
  },
  mounted() {
    if (this.languages.findIndex(l => l === this.localSelected) === -1) {
      this.localSelected = this.languages.length ? this.languages[0] : null;
    }
  },
  methods: {
    selectLanguage(lang) {
      this.localSelected = lang.value;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/language-selector/LanguageSelector.js